<template>
  <div class="subscription-type">
    <div class="top">
      <div class="sun-container">
        <img class="sun" :src="require('@/assets/subscription/sun.svg')"/>
      </div>
      <div class="choose">בחירת סוג מינוי</div>
      <div class="text">לעשות מינוי לרייזאפ זה לשלם על שירות שמחזיר לך את הכסף בחזרה</div>
    </div>

    <div class="options">
      <subscription-type-button-annual
        @subscription-type-selected="selectType"
        :selected="type === SUBSCRIPTION_TYPES.YEARLY" />

      <subscription-type-button-monthly
        @subscription-type-selected="selectType"
        :selected="type === SUBSCRIPTION_TYPES.MONTHLY" />
    </div>

    <div class="disclaimer">המינוי ללא התחייבות ואפשר לבטל בכל שלב</div>

    <div class="button-container">
      <riseup-button :title="'המשך'" :action="onSubmit" :variant="'orange'" :size="'slim'"/>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import { mapActions, mapState, mapMutations } from 'vuex';
import { SUBSCRIPTION_TYPES } from '@/constants/subscription-state';
import SubscriptionTypeButtonAnnual from './SubscriptionTypeButtonAnnual.vue';
import SubscriptionTypeButtonMonthly from './SubscriptionTypeButtonMonthly.vue';

export default {
  name: 'SubscriptionType',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    SubscriptionTypeButtonAnnual,
    SubscriptionTypeButtonMonthly,
  },
  async created() {
    Segment.trackUserGot('SubscriptionTypeEntered');
  },
  data() {
    return {
      SUBSCRIPTION_TYPES,
    };
  },
  computed: {
    ...mapState('subscription', ['type']),
  },
  methods: {
    ...mapActions('subscription', ['moveToCreditCardStep']),
    ...mapMutations('subscription', ['setType']),
    selectType({ subscriptionType }) {
      Segment.trackUserGot('SubscriptionTypeSelected', { subscriptionType });
      this.setType(subscriptionType);
    },
    onSubmit() {
      Segment.trackUserGot('SubscriptionType_MoveToCreditCardStep', { subscriptionType: this.type });
      this.moveToCreditCardStep();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .subscription-type {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .top {
      height: 300px;
      background-color: $riseup_beige;
      padding: 40px;
      border-bottom: 1px solid $riseup_gray_0;

      .sun-container {
        position: relative;
        width: 0;
        height: 0;
        margin-bottom: 56px;

        .sun {
          position: absolute;
          left: -300px;
          top: -114px;
          animation: spin 30s linear infinite;
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        }
      }

      .choose {
        margin-bottom: 8px;
        font-size: 18px;
        line-height: 28px;
        color: $riseup_blue;
      }

      .text {
        font-size: 22px;
        font-weight: bold;
        line-height: 28px;
      }
    }

    .options {
      position: relative;
      top: -50px;

      > div {
        margin-bottom: 24px;
      }
    }

    .disclaimer {
      font-size: 14px;
      margin-top: -50px;
    }

    .button-container {
      width: 100%;
      padding: 24px;
    }
  }
</style>
